// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rKy0PxLwPNgrST_ac7Pv{flex-flow:column wrap;align-items:flex-start;gap:12px;display:flex;position:relative}.dDkRPCIo1ZkrCs_oVok1{flex-wrap:wrap;gap:6px;width:100%;display:flex}.dDkRPCIo1ZkrCs_oVok1+.dDkRPCIo1ZkrCs_oVok1{padding-left:46px}.dDkRPCIo1ZkrCs_oVok1+.dDkRPCIo1ZkrCs_oVok1:before{content:"OR";color:var(--content-primary-primary);align-items:center;padding:0 8px;font-size:13px;font-weight:400;line-height:32px;display:flex;position:absolute;left:0}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"filterGroupList": `rKy0PxLwPNgrST_ac7Pv`,
	"filterGroup": `dDkRPCIo1ZkrCs_oVok1`
};
export default ___CSS_LOADER_EXPORT___;
